"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  maxWidth: _propTypes.string
};
var defaultProps = {
  maxWidth: "1680px",
  mx: "auto",
  position: "relative",
  px: [3, 5, 5, 5, 7],
  width: 1
};
/**
 * Container is a Flex primitive with a max-width prop defaulting to the
 * standard max-width used throughout the site (1570px). Accepts all [Flex]() props.
 */

var Container = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "container__Container",
  componentId: "sc-tstzsp-0"
})([""]);
Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
Container.displayName = "Modules.Container";
var _default = Container;
exports["default"] = _default;